import { keyframes } from "styled-components";

export const fadeInTop = keyframes`
  0% {
    transform: translateY(-50px);
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const fadeOutTop = keyframes`
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    transform: translateY(-50px);
    opacity: 0;
  }
`;
